import React from 'react';

import { TextField, Typography } from '@mui/material';
import { get } from 'lodash';
import { MUIFieldProps } from '../../../../../lib/types/types';
import { MAX_TEXTBOX_LENGTH } from '../../../../../lib/constants/constant';

const MUITextAreaField: React.FC<MUIFieldProps> = (props) => {
	const { label, fieldValue, updateFieldValue, isDisabled, error, errorMessage, ...restProps } = props;

	const maxAllowCharacterLength = get(props, 'maxLength', MAX_TEXTBOX_LENGTH);
	const handleOnchange = (e: React.ChangeEvent<HTMLInputElement>) => {
		let event = { target: { value: get(e, 'target.value', '').slice(0, maxAllowCharacterLength) } };
		updateFieldValue(event as React.ChangeEvent<HTMLInputElement>);
	};
	return (
		<>
			<TextField
				multiline
				id="demo-helper-text-aligned"
				label={label}
				value={fieldValue}
				onChange={handleOnchange}
				disabled={isDisabled}
				error={error}
				helperText={errorMessage}
				minRows={get(props, 'row', 4)}
				maxRows={get(props, 'row', 6)}
				fullWidth
				{...restProps}
			/>
			<Typography variant="caption">
				{fieldValue.length + ' / ' + maxAllowCharacterLength + ' Zeichen (inkl. Leerzeichen) verwendet'}
			</Typography>
		</>
	);
};

export default MUITextAreaField;
